import api from '@/lib/api/client'

export interface SubmitFeedbackPayload {
  surveyKey: string
  score: number
  openText?: string
  context?: Record<string, unknown>
}

export async function submitFeedback(
  payload: SubmitFeedbackPayload,
): Promise<{ id: string; createdAt: string }> {
  const { data } = await api.post('/feedback/responses', payload)
  return data
}
